import React, { useState } from 'react';
import LaunchDisplay from '../LaunchDisplay';
import ReactHtmlParser from 'react-html-parser';
import { baseUrl } from '../../../../../utils';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import { Button } from 'react-bootstrap';

const DigitalSignage = ({ wallData, sideBarMenu, opentSidebar, setopentSidebar }) => {

    const sideBar = sideBarMenu[1]
    const [activeTab, setactiveTab] = useState(1)
    const [content, setContent] = useState(0)

    return (
        <>
            <div id="publish_overlay" className="aside-overlay" />
            <div className="publish_sidebar">
                <Button variant='link' onClick={() => setopentSidebar(opentSidebar ? '' : 'open-sidebar')} className="p-0 publish_toggle_icon border-0 btn" data-factors-form-bind="true" data-factors-click-bind="true">
                    <FontAwesomeIcon type={'solid'} icon={'angles-right'} iconClass={''} />
                </Button>
                <div className="publish_sidebar_area">
                    <h5 className="font-weight-boldest mb-5">Preferred Partner:</h5>
                    <ul className="dashboard-tabs nav flex-wrap p-0 flex-column" role="tablist">
                        {sideBar.map((data, key) => {
                            return (
                                data.content != 'otherSection' ?
                                    <li className="nav-item d-flex">
                                        <a onClick={() => { setactiveTab(data.active); setContent(key) }} className={`nav-link d-flex flex-grow-1 p-0 flex-column align-items-center  ${activeTab == data.active ? `active` : ''}  position-relative overflow-hidden`} data-bs-toggle="pill" data-bs-target={`#${data.icon}`} data-factors-form-bind="true" data-factors-click-bind="true">
                                            <span className="nav-icon w-auto">
                                                <span className="tab-svg-icon">
                                                    <img width={data.width} height={data.height} src={baseUrl(`display-logo/${data.icon}.svg`)} />
                                                </span>
                                            </span>
                                        </a></li> :
                                    <h5 className="font-weight-boldest mb-5 mt-8">Other Platforms:</h5>
                                    )
                                })}
                    </ul>
                </div>
            </div>
            <div className="full_container">
                <div className="card card-custom mb-10">
                    <div className="card-body px-5 px-lg-12 py-10 display-tabs">
                        <div className="small_container">
                            <div className="tab-content mt-lg-10 mt-6">

                                {sideBar.map((data, key) => {

                                    return (

                                        data.content != 'otherSection' ?

                                            <div className={`tab-pane item-fadeIn ${content == key ? `active show` : ``}`} id={data.icon} role="tabpanel" aria-labelledby={`${data.icon}-tab`}>
                                                <div className="form-group mb-lg-10 mb-6">
                                                    <h4 className="mb-6 font-weight-boldest">{data.heading}</h4>
                                                </div>
                                                <div className="form-group mb-lg-10 mb-6">
                                                    <h5 className="mb-4">Step 1 : {data.Step1 ? data.Step1 : 'Copy The Display Wall URL'}  </h5>
                                                    <LaunchDisplay wallData={wallData} lunch={data.lunch} lunchUrlParm={data.lunchUrlParm} />
                                                </div>

                                                <div className="form-group mb-lg-10 mb-6">
                                                    <h5 className="mb-4">Step 2: {data.Step2}</h5>
                                                    {ReactHtmlParser(data.content)}
                                                </div>

                                                <p className="d-flex align-items-center flex-wrap mb-2">
                                                    Need help?
                                                    <a id="tb_vid1" href={`https://vimeo.com/${data.video}`} data-lity className="ms-3 lity_lightbox" data-factors-click-bind="true">
                                                        <FontAwesomeIcon type={'light'} icon={'circle-play'} iconClass={'ms-2 text-gray-500'} />
                                                        <span className="">Watch Video</span>
                                                    </a>
                                                    <span className="d-flex mx-2 text-muted">Or</span>
                                                    <a href={`https://taggbox.com/support/${data.linkUrl}`} target="_blank" className="text-underline" data-factors-click-bind="true">Learn More</a>
                                                </p>
                                            </div> : null

                                    )
                                }
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default DigitalSignage